import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useInRouterContext, useLocation } from 'react-router-dom';
import lsegLogo from '../../assets/images/lseg_logo.svg';
import LsegDisclaimerDialog from './LsegDisclaimerDialog';
import './FooterBrand.less';

export interface FooterBrandProps {
  className?: string;
  nodeId?: string;
  markNodeId?: string;
}

// Keep the shared footer usable in isolated renderers without requiring a router.
const DisclaimerRouteReset: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const { pathname, search } = useLocation();
  const openedAt = useRef({ pathname, search });
  useEffect(() => {
    if (openedAt.current.pathname !== pathname || openedAt.current.search !== search) onClose();
  }, [pathname, search, onClose]);
  return null;
};

/**
 * LSEG footer brand mark area.
 * Figma node 3490:22963 is a 22px-high row with a 45x22 logo aligned right.
 */
const FooterBrand: React.FC<FooterBrandProps> = ({
  className,
  nodeId = '3490:22963',
  markNodeId = '3490:22964',
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);
  const inRouter = useInRouterContext();
  const closeDisclaimer = useCallback(() => setIsOpen(false), []);

  return (
    <footer
      className={`footer-brand${className ? ` ${className}` : ''}`}
      data-node-id={nodeId}
    >
      <button
        ref={triggerRef}
        className="footer-brand__button"
        type="button"
        aria-label="LSEG標準免責を表示"
        aria-haspopup="dialog"
        onClick={() => setIsOpen(true)}
      >
        <img
          className="footer-brand__mark"
          src={lsegLogo}
          alt="LSEG"
          data-node-id={markNodeId}
        />
      </button>
      {isOpen && (
        <>
          {inRouter && <DisclaimerRouteReset onClose={closeDisclaimer} />}
          <LsegDisclaimerDialog returnFocusRef={triggerRef} onClose={closeDisclaimer} />
        </>
      )}
    </footer>
  );
};

export default FooterBrand;
